export const getLegacyPath = path => {
	return '/index.html?page=' + encodeURIComponent(path);
};

/**
 * Parses and processes non-root internal links to determine whether it should be handled as a React or legacy resource reference.
 *
 * @param {string} url link to internal resource
 * @returns {string} conditionally modified version of `url`
 */
export const getPath = url => {
	return url
		? url !== '/index.html' && !url.includes('?redirect=')
			? getLegacyPath(url.trim())
			: url.trim()
		: null;
};

/**
 * Determine whether or not link is to external resource.
 *
 * @param {string} url link to another resource, internal or external
 * @returns {boolean} external resource indication
 */
export const determineIfExternal = url =>
	url !== null &&
	url !== undefined &&
	(url.slice(0, 5) === 'https' || url.slice(0, 4) === 'http');
